<ng-template #view>
  <ax-default-value-view
    [property]="property"
    [showVerificationLabel]="showVerificationLabel"
    [clickable]="false"
  ></ax-default-value-view>
</ng-template>

<ng-container *ngIf="clickable; else view">
  <a
    class="c-card__property__link"
    [href]="property | propertyDocumentLink: (backendUrl$ | async)"
    [attr.download]="(property | propertyDisplayValue) + '.pdf'"
    (click)="downloadPdf(); $event.preventDefault()"
  >
    <ng-container *ngTemplateOutlet="view"></ng-container>
  </a>
</ng-container>
